import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing photo component from webix
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig } from 'config/config'; // Importing development configuration
import { profile } from 'config/config'; // Importing user profile configuration

export default class InformationView extends JetView {
    // Defining InformationView class extending JetView
    config() {
        // Method to define the UI configuration
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Getting the current screen size

        const main_info = {
            // Main information form configuration
            margin: 10,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'id',
                    type: 'number',
                    label: _("<span class='icon-id'></span> ID"), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Id'), // Placeholder text
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                    required: true, // Field is required
                },
                {
                    view: 'text', // Text input for Name
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Nombre'), // Placeholder text
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                    required: true, // Field is required
                },
                {
                    view: 'text', // Text input for Description
                    name: 'Description',
                    label: "<span class='icon-file-text1'></span>" + _('Descripción'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Segundo Nombre'), // Placeholder text
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                    required: true, // Field is required
                },
                {
                    view: 'richselect', // Dropdown for Type of Product
                    name: 'TypeProduct',
                    label: _('Tipo de Producto'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'D', value: _('Deportivo') },
                        { id: 'C', value: _('Casino') },
                    ],
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                    required: true, // Field is required
                },
            ],
        };

        const notifications = {
            // Radio button configuration for notifications
            view: 'radio',
            name: 'notifications',
            label: _('Notificaciones'), // Localized label
            labelPosition: 'top',
            value: 1, // Default value
            options: [
                // Options for the radio buttons
                { id: 1, value: _('Si') },
                { id: 2, value: _('No') },
            ],
        };

        const left_main = {
            // Left section of the form
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Including main_info in the left section
        };

        const more_info = {
            // Additional information form configuration
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [
                {
                    view: 'richselect', // Dropdown for activation status
                    name: 'IsActivate',
                    label: _('Estado'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the dropdown
                        { id: 'A', value: _('Activado') },
                        { id: 'C', value: _('Cancelado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                    required: true, // Field is required
                },
                {
                    view: 'datepicker', // Date picker for start date
                    timepicker: true, // Enable time selection
                    name: 'DateStart',
                    label: _('Fecha Inicio'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    format: webix.Date.dateToStr('%d %M %Y %h:%i %a'), // Date format
                    required: true, // Field is required
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                },
                {
                    view: 'datepicker', // Date picker for end date
                    timepicker: true, // Enable time selection
                    name: 'DateEnd',
                    label: _('Fecha Fin'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    format: webix.Date.dateToStr('%d %M %Y %h:%i %a'), // Date format
                    required: true, // Field is required
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                },
                {
                    view: 'richselect', // Dropdown for Partner selection
                    name: 'Partner',
                    label: _('Partner'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: profile.PartnerSelected, // Default value from profile
                    options: profile.Partners, // Options from profile
                    id: 'Partners', // ID for the component
                    invalidMessage: _('Campo Requerido'), // Error message for invalid input
                    required: true, // Field is required
                },
            ],
        };

        const right_photo = {
            // Right section for photo upload
            gravity: 3,
            margin: 10,
            rows: [
                {
                    view: 'photo', // Photo upload component
                    name: 'photo',
                    css: 'form_photo', // CSS class for styling
                    width: 260, // Width of the photo component
                    height: 260, // Height of the photo component
                    borderless: true, // No border
                },
                {
                    view: 'multicombo', // Multi-select for tags
                    name: 'tags',
                    localId: 'tags:combo', // Local ID for the component
                    placeholder: _('Click to add tags'), // Placeholder text
                    options: [], // Initial options
                },
            ],
        };

        const upper_section = {
            // Upper section layout configuration
            multiview: true, // Enable multi-view
            padding: 10,
            cols: [left_main, { gravity: 0, minWidth: 20 }, more_info], // Columns layout
        };

        const upper_section_narrow = {
            // Narrow layout for smaller screens
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info, more_info], // Rows layout
                },
            ],
        };

        const buttons = {
            // Button configuration
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Save button
                    value: _('Guardar'), // Localized button text
                    type: 'form', // Button type
                    autowidth: true, // Auto width
                    click: () => {
                        // Click event handler
                        if (this.getRoot().validate()) {
                            // Validate the form
                            const newdata = this.getRoot().getValues(); // Get form values
                            var d = new Date(newdata.DateStart); // Parse start date
                            var dateStart =
                                d.getFullYear() +
                                ':' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                ':' +
                                ('00' + d.getDate()).slice(-2) +
                                ' ' +
                                '00:00:00'; // Format start date
                            var dd = new Date(newdata.DateEnd); // Parse end date
                            var dateEnd =
                                dd.getFullYear() +
                                ':' +
                                ('00' + (dd.getMonth() + 1)).slice(-2) +
                                ':' +
                                ('00' + dd.getDate()).slice(-2) +
                                ' ' +
                                '23:59:59'; // Format end date
                            var data = {
                                // Data object to send
                                id: newdata.id,
                                Name: newdata.Name,
                                Description: newdata.Description,
                                TypeProduct: newdata.TypeProduct,
                                IsActivate: newdata.IsActivate,
                                DateStart: dateStart,
                                DateEnd: dateEnd,
                                Partner: newdata.Partner,
                            };
                            if (dateStart < dateEnd) {
                                // Check date validity
                                webix
                                    .ajax() // AJAX request to save data
                                    .headers({
                                        'Content-type': 'application/json', // Set content type
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Leagues/AddLeague', // API endpoint
                                        data, // Data to send
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                // Error callback
                                                webix.message(_('Error')); // Show error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                // Success callback
                                                webix.message({
                                                    text: _(
                                                        'Liga Agregada Correctamente', // Success message
                                                    ),
                                                    title: _('¡Exito!'), // Title for the message
                                                    type: 'alert-warning', // Message type
                                                });
                                            },
                                        },
                                    );
                            } else {
                                // If dates are invalid
                                webix.message({
                                    text: _(
                                        'La Fecha de inicio debe ser menor a la fecha fin.', // Error message
                                    ),
                                    title: _('Error!'), // Title for the message
                                    type: 'alert-error', // Message type
                                });
                            }
                        }
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            view: 'form', // Form view
            rows: [
                screen !== 'small' ? upper_section : upper_section_narrow, // Conditional layout based on screen size
                buttons, // Include buttons
            ],
            elementsConfig: {
                // Configuration for form elements
                on: {
                    onChange: function (newv, oldv) {
                        // Change event handler
                        this.validate(); // Validate on change
                    },
                },
            },
        };
    }

    init(form) {
        // Initialization method
        var vthis = this; // Reference to the current instance
        this.on(this.app, 'form:update2', (id) => {
            // Event listener for form update
            webix
                .ajax() // AJAX request to get league data by ID
                .get(
                    devConfig.geturlApi() + 'League/GetLeagueById',
                    'id=' + id, // Query parameter
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error callback
                            webix.message(_('Error! ')); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success callback
                            text = JSON.parse(text); // Parse response
                            vthis.app.callEvent('customer:updatedata', [
                                text[0], // Call event with the retrieved data
                            ]);
                            $$('country').setValue(text[0].CountryId); // Set country value
                            webix.delay(
                                // Delay for setting values
                                function () {
                                    $$('ProvinceRegion').setValue(
                                        text[0].RegionId, // Set region value
                                    );
                                    webix.delay(
                                        // Nested delay for city value
                                        function () {
                                            $$('City').setValue(text[0].CityId); // Set city value
                                        },
                                        '',
                                        '',
                                        1000,
                                    );
                                },
                                '',
                                '',
                                1000,
                            );
                        },
                    },
                );
        });

        webix
            .ajax() // AJAX request to get agent countries
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error callback
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success callback
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize property names
                            .replace(/"Name"/g, '"value"'),
                    );
                },
            });

        this.on(
            this.app,
            'customer:updatedata',
            (
                person, // Event listener for updating customer data
            ) => form.setValues(person), // Set form values with the person data
        );
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Event listener for person selection
    }

    getLocalizedComboOptions() {
        // Method to get localized options for combo boxes
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get positions data
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parse options into the combo

        let t_options = webix.copy(getTags()); // Get tags data
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parse options into the combo

        let c_options = webix.copy(getCities()); // Get cities data
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parse options into the combo
    }
}

// FILE DOCUMENTED
